import { sendDeviceNotification } from 'src/app/util/notifications';
import { Server } from './server';
import { Service, ServiceResponse } from './service';

const CHAT_DATES_CACHE_EXPIRATION = 60*60*24; 
const CHAT_MESSAGES_CACHE_EXPIRATION = 60*15;
const CHAT_MEMBERS_CACHE_EXPIRATION = 60;

export class ChatService extends Service {

  constructor() {
    super();
  }

  public async init(): Promise<ServiceResponse> {
    await Server.database.purge('CHATDATES#', CHAT_DATES_CACHE_EXPIRATION);
    await Server.database.purge('CHATMESSAGES#', CHAT_MESSAGES_CACHE_EXPIRATION);
    await Server.database.purge('CHATMEMBERS#', CHAT_MEMBERS_CACHE_EXPIRATION);
    return {success: true};
  }

  // cache

  public async setDatesCache(chats:any[], update:boolean = false) {
    await Server.database.putItem(`CHATDATES`, chats, update);
  }

  public async getDatesCache() {
    return await Server.database.getItem(`CHATDATES`, CHAT_DATES_CACHE_EXPIRATION);
  }

  public async clearDatesCache() {
    await Server.database.removeItem(`CHATDATES`);
  }

  public async setMessagesCache(id:string, cache:any, update:boolean = false) {
    await Server.database.putItem(`CHATMESSAGES#${id}`, cache, update);
  }

  public async getMessagesCache(id:string) {
    return await Server.database.getItem(`CHATMESSAGES#${id}`, CHAT_MESSAGES_CACHE_EXPIRATION);
  }

  public async setMembersCache(id:string, members:string[], update:boolean = false) {
    await Server.database.putItem(`CHATMEMBERS#${id}`, members, update);
  }

  public async getMembersCache(id:string) {
    return await Server.database.getItem(`CHATMEMBERS#${id}`, CHAT_MEMBERS_CACHE_EXPIRATION);
  }


  // commands
  protected async sendChatCommand(command:string, params:any = {}, data?:string[]) {
    let response = await this.sendCommand('chat/v3', command, params);
    if(response.status != 200)
      return {success: false, message: response.body.message};
    let ret:any = {success: true};
    if(data) {
      for(let i = 0; i < data.length; i++)
        ret[data[i]] = response.body[data[i]];
    }
    return ret;
  }
    
  public async startChat(params: {type:string, members:string[], name?:string}) {
    return await this.sendChatCommand('start-chat', params, ['id']);
  }

  public async updateChat(params: {id:string, type:string, members:string[], name:string}) {
    return await this.sendChatCommand('update-chat', params);
  }

  public async leaveChat(params: {id:string, type:string}) {
    return await this.sendChatCommand('leave-chat', params);
  }

  public async getChats() {
    return await this.sendChatCommand('get-chats', {}, ['chats']);
  }

  public async getChatMembers(id:string) {
    return await this.sendChatCommand('get-chat-members', {id}, ['members']);
  }

  public async getChatDates(params:any = {}) {
    return await this.sendChatCommand('get-chat-dates', params, ['chats']);
  }

  public async getChatMessages(id:string, params:any = {}) {
    return await this.sendChatCommand('get-chat-messages', {id, ...params}, ['messages', 'users']);
  }

  public async sendChatMessage(id:string, message:string) {
    return await this.sendChatCommand('send-chat-message', {id, message}, ['date']);
  }
}

